import { render, staticRenderFns } from "./ApplicationHistoricComponent.vue?vue&type=template&id=910b1610&scoped=true&"
import script from "./ApplicationHistoricComponent.vue?vue&type=script&lang=js&"
export * from "./ApplicationHistoricComponent.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationHistoricComponent.vue?vue&type=style&index=0&id=910b1610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910b1610",
  null
  
)

export default component.exports